import { Component, AfterViewInit, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ResizeEvent } from 'angular-resizable-element';
import { AuthService } from '../services/auth.service';
import * as io from 'socket.io-client';
import { Router } from '@angular/router';
import { GpsService } from '../services/gps.service';
import swal from 'sweetalert';
import * as jsts from 'jsts';
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
// News impots
import * as moment from 'moment-timezone';
import { NgxSpinnerService } from 'ngx-spinner';
// News impots
import { ExcelService } from '../services/excel.service';
import * as leafletPip from '@mapbox/leaflet-pip';
// Operadores
import { OperadoresService } from '../services/operadores.service';
import * as modal from 'bootstrap';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { THIS_EXPR, ifStmt } from '@angular/compiler/src/output/output_ast';
// Usuarios & Restablecer contraseña
import { UsuariosService } from '../services/usuarios.service';
// Usuarios & Restablecer contraseña


declare let L: any;
declare let google: any;

@Component({
  selector: 'app-operadores',
  templateUrl: './operadores.component.html',
  styleUrls: ['./operadores.component.css']
})
export class OperadoresComponent implements OnInit {
  subscribeUsuarios: any;
  @Input()
  public myInput: MouseEvent;

  constructor(
    private gps: GpsService,
    public auth: AuthService,
    private toastr: ToastrService,
    private router: Router,
    public jwtHelper: JwtHelperService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private operadoresService: OperadoresService,
    private usuarios: UsuariosService
  ) {
    moment.locale('es');
  }

  @ViewChild('info') info: ElementRef;

  // Variables para Soket
  private url = 'https://vigiliner.com.mx:1798';
  private socket;
  // Variables para Mapa
  public L: any;
  public google: any;
  public map;
  // Variables para GPS
  public markers = new L.FeatureGroup();
  public filtro = '';
  public style: object = {};
  public dispositivo = {};
  public dispositivoss = [];
  public divInformacion: object;
  public arrayOfKeys;
  public seteo_valoresseteo_valores = true;
  public datosXls: Array<any> = [];
  public respuestaParo: any;
  // Variables Reportes
  public formModel = {
    fechastart: moment().format('YYYY-MM-DD'),
    horastart: '00:00',
    fechaend: moment().format('YYYY-MM-DD'),
    horaend: moment().format('HH:mm')
  };
  public errorFechas = null;
  public divReportes: Array<any> = [];
  public selecTipo = 'todos';
  public markersRecorrido = [];
  public markersMovimiento = new L.layerGroup();
  public markersParadaMenor = new L.layerGroup();
  public markersParadaMayor = new L.layerGroup();
  public markersEstacionado = new L.layerGroup();
  public markersTodos = new L.layerGroup();
  public displayedmarkers;
  public polyline = new L.layerGroup();
  public polylineDecora = new L.layerGroup();
  // Variable para permiso de envio de comandos
  public comandos: boolean;
  // Variables Geocercas
  public drawMenu;
  public drawnItems;
  public geocercasList = [];
  // Variables para Operadores
  model: any = {};
  public listadoOperadores: Array<any> = [];
  public listadoAsignacion: Array<any> = [];
  public listadoIncidencias: Array<any> = [];
  historial: any = {};
  public unidadesXoperador: Array<any> = [];
  // Variables para Unidades
  public listadoUnidades: Array<any> = [];
  public servicioUnidades = {};
  public iconos: Array<any> = [];
  public colores: Array<any> = [];
  public historialUnidad = [];
  public listadoAsignaciones: Array<any> = [];
  public listadoServicios: Array<any> = [];
  // Variables para Usuarios
  public listadoUsuarios: Array<any> = [];
  public TodasUnidades: Array<any> = [];

  public contadorOfoto = true;
  public contadorPersonasE = 0;
  public contadorPersonasS = 0;

 
 

  /**
   * Se muestra todo lo que carga de entrada que son
   * Las unidades, operadores usuarios, validar si ha echo el cambio
   * inicial de contraseña, revisar que permisos tiene el usuario
   *
  **/
  ngOnInit() {
    //  Valida si tienes permisos para enviar comandos
    // tslint:disable-next-line:triple-equals
    if (this.jwtHelper.decodeToken(localStorage.getItem('access_token')).permisoID == 4) {
      this.comandos = false;
    } else {
      this.comandos = true;
    }
    document.oncontextmenu = function () { return false; };
   
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoUsuarios Se almacenan la informacion de los usuarios
    **/
    this.usuarios.listadoUsiarios().toPromise().then(result => {
      const temporal: Array<any> = [];
      result.forEach(element => {
        temporal.push({
          usuarioID: element.usuarioID,
          nombres: element.nombres,
          apellidos: element.apellidos,
          email: element.email,
          telefono: (element.telefono == null || element.telefono === '') ? 'Sin teléfono' : element.telefono,
          unidadesAlias: (element.unidadesAlias == null) ? 'No hay unidades asignadas' : element.unidadesAlias,
          unidadesID: (element.unidadesID == null) ? null : element.unidadesID.split(',')
        });
      });
      this.listadoUsuarios = temporal;
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param listadoOperadores Se almacenan la informacion de los operadores
    **/
    this.operadoresService.listadoOperadores().toPromise().then(result => {
        const temporal: Array<any> = [];
        result.forEach(element => {
          const dateNow = moment();
                  let faltan = ' --- ', clase = '';
                  const fechaAvisar = moment(element.vigencia, 'YYYY-MM-DD').subtract(30, 'days');
                  if (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                    faltan = 'Falta ' + moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                  } else if (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                    faltan = 'Falta ' + moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                  } else if (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                    faltan = 'Falta ' + moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                  } else if (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                    faltan = 'Falta ' + moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                  } else if (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                    faltan = 'Necesita ser renovada.';
                  } else {
                    faltan = 'Necesita ser renovada. Se ha pasado por ' + (moment(element.vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                  }
                  if (dateNow.isBetween(fechaAvisar, element.vigencia)) {
                    clase = 'table-warning';
                  } else if (dateNow.isSameOrAfter(element.vigencia)) {
                    clase = 'table-danger';
                  }
          temporal.push({
            id: element.id,
            uid: element.uid,
            nombre: element.nombre,
            paterno: element.paterno,
            materno: element.materno,
            empleado: (element.empleado === null) ? ' --- ' : element.empleado,
            licencia: element.licencia,
            vigencia: moment(element.vigencia, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            faltan: faltan
          });
        });
        this.listadoOperadores = temporal;
      },
      err => {
        this.auth.logout();
        this.router.navigate(['login']);
      }
    );
    /**
      * Funcion para mostrar los usuarios y sus unidades asignadas
      * @param temporal Sirve para validar algunos campos
      * @param dispositivo Se almacenan la informacion de las unidades
      * Su ultimo reporte, coordenadas, estado, etc.
      * @param dispositivoss sirve para mantener el orden de las unidades
      * @param markers Todas las unidades para mostrar en el mapa
    **/
    this.gps.getTodos().toPromise().then(result => {
      const temporal = this.listadoUnidades;
      this.dispositivoss = result;
      result.forEach(elemento => {
        // @ts-ignore
        this.dispositivo[elemento.imei] = elemento;
        let clase = '', faltan = 'Falta ';
        if (elemento.fechaServicio != null) {
          const dateNow = moment();
          const periodo = elemento.periodo.split('-');
          const fechaAvisar = moment(elemento.fechaServicio).subtract(periodo[0], periodo[1]).format('YYYY-MM-DD');
          if (dateNow.isBefore(fechaAvisar)) {
            clase = '';
          } else if (dateNow.isBetween(fechaAvisar, elemento.fechaServicio)) {
            clase = 'table-warning';
          } else if (dateNow.isSameOrAfter(fechaAvisar)) {
            clase = 'table-danger';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
            faltan += moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
            faltan = 'Necesita servicio por fecha.';
          }
          if (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') < 0) {
            faltan = 'Necesita servicio por fecha. Se ha pasado por ' +
              (moment(elemento.fechaServicio, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
          }
        }
        let periodo_ = '';
        switch (elemento.periodo) {
          case '1-month':
            periodo_ = '1 Mes';
            break;
          case '2-month':
            periodo_ = '2 Meses';
            break;
          case '3-month':
            periodo_ = '3 Meses';
            break;
          case '4-month':
            periodo_ = '4 Meses';
            break;
          default:
            periodo_ = '';
            break;
        }
        temporal.push({
          imei: elemento.imei,
          uidUnidad: elemento.uidUnidad,
          alias: elemento.alias,
          // tslint:disable-next-line:max-line-length
          modelo: (elemento.marca == null && elemento.modelo == null && elemento.anio == null) ? ' --- ' : elemento.marca + ' ' + elemento.modelo + ' ' + elemento.anio,
          serie: elemento.serie,
          placas: (elemento.placas == null) ? ' --- ' : elemento.placas,
          consumo: (elemento.consumo == null) ? ' --- ' : elemento.consumo,
          icono: elemento.icono,
          color: elemento.color,
          fechaServicio: (elemento.fechaServicio == null) ? ' --- ' : moment(elemento.fechaServicio).format('DD-MM-YYYY'),
          periodo: (elemento.periodo == null) ? '' : elemento.periodo,
          txtperiodo: (periodo_ === '') ? ' --- ' : periodo_,
          faltan: (elemento.fechaServicio == null) ? '' : 'Por fecha: ' + faltan,
          clase: clase,
          km: (elemento.kmServicio == null) ? ' --- ' : elemento.kmServicio,
          kmActual: 'Procesando...',
          faltanKM: '',
          claseKm: '',
          uidOperador: elemento.uidOperador,
          // tslint:disable-next-line:max-line-length
          operador: (elemento.nombre == null && elemento.paterno == null && elemento.materno == null) ? 'Sin asignación' : elemento.nombre + ' ' + elemento.paterno + ' ' + elemento.materno,
          licencia: (elemento.licencia == null) ? 'Sin asignación' : elemento.licencia,
          uidGeo: elemento.uidGeo,
          nombreGeo: (elemento.nombreGeo == null) ? 'Sin asignación' : elemento.nombreGeo
        });
        // @ts-ignore
        if (elemento.json != null) {
          // @ts-ignore
          this.dispositivo[elemento.imei].geocerca = L.geoJSON(JSON.parse(elemento.json), {});
        }
        this.dispositivo[elemento.imei].visible = true;
        this.dispositivo[elemento.imei].posicion = {};
        // contador personas
        this.dispositivo[elemento.imei].contadorPersonasE = 0;
        this.dispositivo[elemento.imei].contadorPersonasS = 0;
        this.dispositivo[elemento.imei].sensorGasolina = {};
        this.dispositivo[elemento.imei].sensorGasolina.porcentaje = 0;
        this.dispositivo[elemento.imei].sensorGasolina.volumen = 0;
        this.dispositivo[elemento.imei].sensorGasolina.claseFuelSensor = 'danger';
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].fecha !== undefined) {
          // @ts-ignore
          const diff = moment().diff(elemento.estado[0].fecha, 'hours');
          // tslint:disable-next-line:curly
          if (diff <= 1) {
            this.dispositivo[elemento.imei].estatus = 'online';
          } else if (diff > 1 && diff <= 24) {
            this.dispositivo[elemento.imei].estatus = 'offline';
          } else {
            this.dispositivo[elemento.imei].estatus = 'error';
          }

          // @ts-ignore
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = moment(elemento.estado[0].fecha);
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = moment(elemento.estado[0].fecha).format('dddd DD [de] MMMM [de] YYYY, h:mm:ss a');
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
          this.dispositivo[elemento.imei].time = setInterval(() => {
            if (this.dispositivo[elemento.imei].fechaHoraUltimoReporte) {
              // tslint:disable-next-line:max-line-length
              this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = this.diferenciaTiempo(this.dispositivo[elemento.imei].fechaHoraUltimoReporte, elemento.imei);
            }
          }, 60000);
        } else {
          this.dispositivo[elemento.imei].ultimo_reporte = false;
          this.dispositivo[elemento.imei].tiempoDesdeUltimoReporte = 'N/A';
          this.dispositivo[elemento.imei].fechaHoraUltimoReporte = false;
          this.dispositivo[elemento.imei].fechaHoraUltimoReporteFormato = '-';
        }
        // @ts-ignore
        if (elemento.estado !== undefined && elemento.estado[0] !== undefined && elemento.estado[0].ultimas_coordenadas[0] !== undefined) {
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Altitude = elemento.estado[0].ultimas_coordenadas[0].trama.Altitude;
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Longitude = elemento.estado[0].ultimas_coordenadas[0].trama.Longitude;
          // @ts-ignore
          // tslint:disable-next-line:radix
          this.dispositivo[elemento.imei].posicion.Azimuth = parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth);
          // @ts-ignore
          this.dispositivo[elemento.imei].posicion.Latitude = elemento.estado[0].ultimas_coordenadas[0].trama.Latitude;
          // Agregado
          // tslint:disable-next-line:max-line-length
          const icono = (this.dispositivo[elemento.imei].icono == null || this.dispositivo[elemento.imei].icono.length === 0) ? 'default' : this.dispositivo[elemento.imei].icono;
          // tslint:disable-next-line:max-line-length
          const color = (this.dispositivo[elemento.imei].color == null || this.dispositivo[elemento.imei].color.length === 0) ? 'black' : this.dispositivo[elemento.imei].color;

          // Kilometraje
          // @ts-ignore
          if ((elemento.estado[0].ultimas_coordenadas[0].trama.Mileage) !== undefined) {
            const indexUnidad = temporal.map(x => x.imei).indexOf(elemento.imei);
            if (indexUnidad !== -1) {
              if (temporal[indexUnidad].km !== ' --- ') {
                let falta = null;
                const km = parseFloat(temporal[indexUnidad].km);
                // @ts-ignore
                // tslint:disable-next-line:max-line-length
                if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage >= (km - 200) && elemento.estado[0].ultimas_coordenadas[0].trama.Mileage < km) {
                  temporal[indexUnidad].claseKm = 'table-warning';
                  // @ts-ignore
                  falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                } else
                  // @ts-ignore
                  if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage === km) {
                    temporal[indexUnidad].claseKm = 'table-danger';
                    falta = 'Necesita servicio por kilometraje.';
                  } else
                    // @ts-ignore
                    if (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage > km) {
                      temporal[indexUnidad].claseKm = 'table-danger';
                      // @ts-ignore
                      // tslint:disable-next-line:max-line-length
                      falta = 'Necesita servicio por kilometraje. Se ha pasado por  ' + (elemento.estado[0].ultimas_coordenadas[0].trama.Mileage - km).toFixed(2) + ' Km.';
                    } else {
                      // @ts-ignore
                      falta = 'Faltan ' + (km - elemento.estado[0].ultimas_coordenadas[0].trama.Mileage).toFixed(2) + ' Km.';
                    }
                temporal[indexUnidad].faltanKM = (falta == null) ? '' : '\n Por kilometraje: ' + falta;
              }
              // @ts-ignore
              temporal[indexUnidad].kmActual = elemento.estado[0].ultimas_coordenadas[0].trama.Mileage;
            }
            // Agregado
          }

          // Agregado
          const customPopup = '<table><tr><th colspan="2" aling="center">' + this.dispositivo[elemento.imei].alias + '</th></tr></table>';
          // @ts-ignore
          // tslint:disable-next-line:max-line-length
          this.dispositivo[elemento.imei].marker = L.marker([elemento.estado[0].ultimas_coordenadas[0].trama.Latitude, elemento.estado[0].ultimas_coordenadas[0].trama.Longitude],
            {
              rotationOrigin: 'center center'
            })
            .bindPopup(customPopup)
            .on('mouseover', function (e) {
              this.openPopup();
            })
            .on('mouseout', function (e) {
              this.closePopup();
            })
            .setIcon(L.divIcon({
              html: '',
              iconSize: [50, 50],
              // @ts-ignore
              // tslint:disable-next-line:max-line-length
              className: elemento.imei + ' ' + icono + color + ' ' + this.icono(parseInt(elemento.estado[0].ultimas_coordenadas[0].trama.Azimuth))
            }));

          this.dispositivo[elemento.imei].paroDeMotor = false;
          this.dispositivo[elemento.imei].salidaTres = false;

          this.divInformacion = this.dispositivo[elemento.imei];

    

          this.markers.addLayer(this.dispositivo[elemento.imei].marker);

          if (this.dispositivo[elemento.imei].geocerca !== undefined) {
            // tslint:disable-next-line:max-line-length
            if (leafletPip.pointInLayer([this.dispositivo[elemento.imei].posicion.Latitude, this.dispositivo[elemento.imei].posicion.Longitude], this.dispositivo[elemento.imei].geocerca).length === 0) {
              this.dispositivo[elemento.imei].classGeocerca = 'text-danger';
            } else {
              this.dispositivo[elemento.imei].classGeocerca = '';
            }
          }

        }

        try {
          // @ts-ignore
          this.seteo_valores(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
          // @ts-ignore
          this.can100(elemento.imei, elemento.estado[0].ultimas_coordenadas[0].trama);
        } catch (error) {

        }

      });
    },
      err => { this.auth.logout(); this.router.navigate(['login']); }
    );
  }



  // Funciones para Operadors
  /**
   * Abre la ventana donde se muestra los operadores
  **/
  verOperadores() {
    document.getElementById('ventanOperador').classList.add('abrir');
  }
  /**
   * Cierra la ventana donde se muestran los operadores
  **/
  cerrarOperadores() {
    document.getElementById('ventanOperador').classList.remove('abrir');
  }
  /**
   * Hace que el campo solo acepte letras y espacios unicamente
   * @param e evento de presionar las teclas
  **/
  soloLetras(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyzÁÉÍÓÚáéíóúÜü ';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
   * Hace que el campo solo acepte numeros.
   * @param e evento de presionar las teclas
  **/
  soloNumeros(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = '1234567890';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
    * Pra mostrar el tiempo que lleva sin reportar el gps
    * @param nombre Fecha de ultimo reporte
    * @param imei Identificador de unidad
  **/
 diferenciaTiempo(tiempo, imei) {
  let cantidad;
  const now = moment([]);
  let time;

  if ((cantidad = (now.diff(tiempo, 'years'))) > 0) {
    if (cantidad === 1) {
      time = 'Hace ' + cantidad + ' año.';
    } else {
      time = 'Hace ' + cantidad + ' años.';
    }
  } else if ((cantidad = (now.diff(tiempo, 'months'))) > 0) {
    time = 'Hace ' + cantidad + ' m';
  } else if ((cantidad = (now.diff(tiempo, 'days'))) > 0) {
    this.dispositivo[imei].estatus = 'error';
    time = 'Hace ' + cantidad + ' d';
  } else if ((cantidad = (now.diff(tiempo, 'hours'))) > 0) {
    time = 'Hace ' + cantidad + ' h';
    this.dispositivo[imei].estatus = 'offline';
  } else if ((cantidad = (now.diff(tiempo, 'minutes'))) > 0) {
    this.dispositivo[imei].estatus = 'online';
    time = 'Hace ' + cantidad + ' min';
  } else if ((cantidad = (now.diff(tiempo, 'seconds'))) >= 0) {
    time = 'Hace unos segundos';
  } else {
    time = '-';
  }

  return time;
}
  /**
   * Hace que el campo solo acepte numeros y punto.
   * @param e evento de presionar las teclas
  **/
  puntoNumeros(e) {
    const key = e.keyCode || e.which;
    const tecla = String.fromCharCode(key).toLowerCase();
    const letras = '1234567890.';
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for (const i in especiales) {
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) === -1 && !tecla_especial) {
      return false;
    }
  }
  /**
   * Prepara las variables para su uso en el modal
   * de nuevo operador, tambien para los errores
   * @param model que contien:
   * @param newnombre Nombre(s) del operador
   * @param newpaterno Apellido paterno
   * @param newmaterno Apellido maternp
   * @param newempleado Numero de empleado
   * @param newlicencia Numero de licencia
   * @param newfecha Vigencia de la licencia
  **/
  modalNuevoOperador() {
    this.model = {};
    this.model = {
      newnombre: '',
      newpaterno: '',
      newmaterno: '',
      newempleado: '',
      newlicencia: '',
      newfecha: ''
    };
    $('#nuevo_nombremailHelp').html('');
    $('#nuevo_paternoHelp').html('');
    $('#nuevo_maternoHelp').html('');
    $('#nuevoempleadoHelp').html('');
    $('#nuevolicenciaHelp').html('');
    $('#nuevofechaHelp').html('');
  }
  /**
   * Valida los datos ingresados por el usuario para ola creacion del operador
   * @param newnombre Nombre(s) del operador
   * @param newpaterno Apellido paterno
   * @param newmaterno Apellido maternp
   * @param newempleado Numero de empleado
   * @param newlicencia Numero de licencia
   * @param newfecha Vigencia de la licencia
  **/
  nuevoOperador() {
    let errornombre = null, errorpaterno = null, errormaterno = null, errorlicencia = null, errorempleado = null, errorfecha = null, nuevoempleado;
    if (this.model.newnombre.length === 0 || this.model.newnombre === '') {
      errornombre = 'Campo obligatorio';
    }
    if (this.model.newpaterno.length === 0 || this.model.newpaterno === '') {
      errorpaterno = 'Campo obligatorio';
    }
    if (this.model.newmaterno.length === 0 || this.model.newmaterno === '') {
      errormaterno = 'Campo obligatorio';
    }
    if (this.model.newempleado === '' || this.model.newempleado.length === 0) {
      nuevoempleado = null;
    } else {
      if (!isNaN(parseInt(this.model.newempleado))) {
        nuevoempleado = this.model.newempleado;
      } else {
        errorempleado = 'Campo debe contener solo números';
      }
    }
    if (this.model.newlicencia.length === 0 || this.model.newlicencia === '') {
      errorlicencia = 'Campo obligatorio';
    } else if (this.model.newlicencia.length < 12 || this.model.newlicencia.length > 15) {
      errorlicencia = 'Campo de contener de 12 a 15 caracteres';
    } else {
      let indexOperador = -1;
      indexOperador = this.listadoOperadores.map(x => x.licencia).indexOf(this.model.newlicencia);
      if (indexOperador !== -1) {
        errorlicencia = 'Campo debe ser unico.';
      }
    }
    if (this.model.newfecha.length === 0 || this.model.newfecha === '') {
      errorfecha = 'Campo obligatorio';
    }
    if (errornombre == null && errorpaterno == null && errormaterno == null && errorempleado == null && errorlicencia == null && errorfecha == null) {
      const datos = '\nNombre: ' + this.model.newnombre +
        '\nApellido Paterno: ' + this.model.newpaterno +
        '\nApellido Paterno: ' + this.model.newmaterno +
        '\nN. Empleado: ' + nuevoempleado +
        '\nN. Licencia: ' + this.model.newlicencia +
        '\nN. Vigencia de licencia: ' + moment(this.model.newfecha, 'YYYY-MM-DD').format('DD-MM-YYYY');
      swal({
        title: '¡Nuevo Operador!',
        text: 'Se creara con los siguientes datos:' + datos + '\n¿Deseas crear al operador?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CREAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'CREAR') {
              swal('¡Error!', 'No se ha escrito \'CREAR\' correctamente', 'error');
            } else {
              this.operadoresService.nuevOperador(this.model.newnombre, this.model.newpaterno, this.model.newmaterno, nuevoempleado, this.model.newlicencia, this.model.newfecha).toPromise().then(data => {
                if (data.length > 0) {
                  $('#nuevooperador').modal('hide');
                  const epleadotd = (data[0].empleado == null) ? ' --- ' : data[0].empleado;
                  // $('#tableOperadores > tbody').append('<tr id="operador'+data[0].uid+'" role="row"><th scope="row" class="sorting_1">'+data[0].uid+'</th><td>'+data[0].nombre+' '+data[0].paterno+' '+data[0].materno+'</td><td>'+epleadotd+'</td><td>'+data[0].licencia+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="editarOperador('+data[0].uid+')" data-toggle="modal" data-target="#editaroperadores" style="padding: 0.1rem .3rem;margin-right: 3px;">Editar</button><button class="btn btn-danger btn-sm btonesO" (click)="editarOperador('+data[0].uid+')" style="padding: 0.1rem .3rem;margin-right: 3px;">Eliminar</button><button class="btn btn-warning btn-sm" (click)="historicoOperdaores('+data[0].uid+')" data-fancybox data-src="#historialOperador" data-modal="true" href="javascript:;" style="padding: 0.1rem .3rem;">Historial</button></td></tr>');
                  const dateNow = moment();
                  let faltan = ' --- ', clase = '';
                  const fechaAvisar = moment(data[0].vigencia, 'YYYY-MM-DD').subtract(30, 'days');
                  if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                    faltan = 'Falta ' + moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                  } else if (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                    faltan = 'Necesita ser renovada.';
                  } else {
                    faltan = 'Necesita ser renovada. Se ha pasado por ' + (moment(data[0].vigencia, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                  }
                  if (dateNow.isBetween(fechaAvisar, data[0].vigencia)) {
                    clase = 'table-warning';
                  } else if (dateNow.isSameOrAfter(data[0].vigencia)) {
                    clase = 'table-danger';
                  }
                  this.listadoOperadores.push({
                    id: data[0].id,
                    uid: data[0].uid,
                    nombre: data[0].nombre,
                    paterno: data[0].paterno,
                    materno: data[0].materno,
                    empleado: epleadotd,
                    licencia: data[0].licencia,
                    vigencia: moment(data[0].vigencia, 'YYYY-MM-DD').format('DD-MM-YYYY'),
                    faltan: faltan,
                    clase: clase
                  });
                  swal('Se ha creado correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al crear un operador',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#nuevo_nombremailHelp').html(errornombre);
      $('#nuevo_paternoHelp').html(errorpaterno);
      $('#nuevo_maternoHelp').html(errormaterno);
      $('#nuevoempleadoHelp').html(errorempleado);
      $('#nuevolicenciaHelp').html(errorlicencia);
      $('#nuevofechaHelp').html(errorfecha);
    }
  }
  /**
   * Prepara las variables para su uso en el modal
   * de editar operador cargando los datos, tambien para los errores
   * @param ename Nombre(s) del operador
   * @param epaterno Apellido paterno
   * @param ematerno Apellido maternp
   * @param eempleado Numero de empleado
   * @param elicencia Numero de licencia
   * @param evigencia Vigencia de la licencia
   * @param uid Identificador del operador
  **/
  modalediatar(uid) {
    this.model = {};
    const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
    this.model = {
      ename: this.listadoOperadores[indiceOperador].nombre,
      epaterno: this.listadoOperadores[indiceOperador].paterno,
      ematerno: this.listadoOperadores[indiceOperador].materno,
      eempleado: (this.listadoOperadores[indiceOperador].empleado === ' --- ') ? null : this.listadoOperadores[indiceOperador].empleado,
      elicencia: this.listadoOperadores[indiceOperador].licencia,
      evigencia: moment(this.listadoOperadores[indiceOperador].vigencia, 'DD-MM-YYYY').format('YYYY-MM-DD'),
      euid: uid,
      index: indiceOperador
    };
    $('#editarnombremailHelp').html('');
    $('#editarpaternoHelp').html('');
    $('#editarmaternoHelp').html('');
    $('#editarmpleadoHelp').html('');
    $('#editaricenciaHelp').html('');
    $('#editarfechaHelp').html('');
  }
  /**
   * Valida los datos ingresados por el usuario para la edicion
   * @param ename Nombre(s) del operador
   * @param epaterno Apellido paterno
   * @param ematerno Apellido maternp
   * @param eempleado Numero de empleado
   * @param elicencia Numero de licencia
   * @param evigencia Vigencia de la licencia
   * @param uid Identificador del operador
  **/
  editarOperador(uid) {
    let errornombre = null, errorpaterno = null, errormaterno = null, errorlicencia = null, errorempleado = null, errorfecha = null, nuevoempleado;
    if (this.model.ename === undefined || this.model.ename.length === 0) {
      errornombre = 'Campo obligatorio';
    }
    if (this.model.epaterno === undefined || this.model.epaterno.length === 0) {
      errorpaterno = 'Campo obligatorio';
    }
    if (this.model.ematerno === undefined || this.model.ematerno.length === 0) {
      errormaterno = 'Campo obligatorio';
    }
    if (this.model.eempleado === undefined || this.model.eempleado.length === 0) {
      nuevoempleado = null;
    } else {
      if (!isNaN(parseInt(this.model.eempleado))) {
        nuevoempleado = this.model.eempleado;
      } else {
        errorempleado = 'Campo debe contener solo números';
      }
    }
    if (this.model.elicencia === undefined || this.model.elicencia.length === 0) {
      errorlicencia = 'Campo obligatorio';
    } else if (this.model.elicencia.length < 12 || this.model.elicencia.length > 15) {
      errorlicencia = 'Campo de contener de 12 a 15 caracteres';
    } else {
      let indexOperador = -1;
      indexOperador = this.listadoOperadores.map(x => x.licencia).indexOf(this.model.elicencia);
      if (indexOperador !== -1 && this.model.index !== indexOperador) {
        errorlicencia = 'Campo debe ser unico.';
      }
    }
    if (this.model.evigencia.length === 0 || this.model.evigencia === '') {
      errorfecha = 'Campo obligatorio';
    }
    if (errornombre == null && errorpaterno == null && errormaterno == null && errorempleado == null && errorlicencia == null) {
      const datos = '\nNombre: ' + this.model.ename +
        '\nApellido Paterno: ' + this.model.epaterno +
        '\nApellido Paterno: ' + this.model.ematerno +
        '\nN. Empleado: ' + nuevoempleado +
        '\nN. Licencia: ' + this.model.elicencia +
        '\nN. Vigencia de licencia: ' + moment(this.model.evigencia, 'YYYY-MM-DD').format('DD-MM-YYYY');
      swal({
        title: '¡Editar Operador!',
        text: 'Se modificará con los siguientes datos:' + datos + '\n¿Deseas modificar al operador?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'EDITAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'EDITAR') {
              swal('¡Error!', 'No se ha escrito \'EDITAR\' correctamente', 'error');
            } else {
              const empleado = (this.model.eempleado == null || this.model.eempleado.length === 0) ? null : this.model.eempleado;
              this.operadoresService.actualizarOperador(this.model.ename, this.model.epaterno, this.model.ematerno, empleado, this.model.elicencia, this.model.evigencia, uid).toPromise().then(data => {
                if (data['affectedRows'] === 1 && data['warningCount'] === 0) {
                  const dateNow = moment();
                  let faltan = ' --- ', clase = '';
                  const fechaAvisar = moment(this.model.evigencia, 'YYYY-MM-DD').subtract(30, 'days');
                  if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'years') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'years') + ' años.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'months') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'months') + ' meses.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'weeks') + ' semanas.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') > 0) {
                    faltan = 'Falta ' + moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') + ' días.';
                  } else if (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') === 0) {
                    faltan = 'Necesita ser renovada.';
                  } else {
                    faltan = 'Necesita ser renovada. Se ha pasado por ' + (moment(this.model.evigencia, 'YYYY-MM-DD').diff(dateNow, 'days') * -1) + ' días.';
                  }
                  if (dateNow.isBetween(fechaAvisar, this.model.evigencia)) {
                    clase = 'table-warning';
                  } else if (dateNow.isSameOrAfter(this.model.evigencia)) {
                    clase = 'table-danger';
                  }
                  const eempleado = (this.model.eempleado == null || this.model.eempleado.length === 0) ? ' --- ' : this.model.eempleado;
                  this.listadoOperadores[this.model.index].nombre = this.model.ename;
                  this.listadoOperadores[this.model.index].paterno = this.model.epaterno;
                  this.listadoOperadores[this.model.index].materno = this.model.ematerno;
                  this.listadoOperadores[this.model.index].empleado = eempleado;
                  this.listadoOperadores[this.model.index].licencia = this.model.elicencia;
                  this.listadoOperadores[this.model.index].vigencia = moment(this.model.evigencia, 'YYYY-MM-DD').format('DD-MM-YYYY');
                  this.listadoOperadores[this.model.index].faltan = faltan;
                  this.listadoOperadores[this.model.index].clase = clase;
                  $('#editaroperadores').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                  // $("#operador"+uid).html('<th scope="row">'+uid+'</th><td>'+this.model.ename+' '+this.model.epaterno+' '+this.model.ematerno+'</td><td>'+eempleado+'</td><td>'+this.model.elicencia+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="editarOperador('+uid+')" data-toggle="modal" data-target="#editaroperadores" style="padding: 0.1rem .3rem;margin-right: 3px;">Editar</button> <button class="btn btn-danger btn-sm btonesO" (click)="editarOperador('+uid+')" style="padding: 0.1rem .3rem;margin-right: 3px;">Eliminar</button><button class="btn btn-warning btn-sm" style="padding: 0.1rem .3rem; ">Historial</button></td>');
                } else {
                  swal({
                    title: 'Hubo un error al editar el operador',
                    icon: 'error',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#editarnombremailHelp').html(errornombre);
      $('#editarpaternoHelp').html(errorpaterno);
      $('#editarmaternoHelp').html(errormaterno);
      $('#editarmpleadoHelp').html(errorempleado);
      $('#editaricenciaHelp').html(errorlicencia);
      $('#editarfechaHelp').html(errorfecha);
    }
  }
  /**
   * Se elimina el operador
   * @param uid Identificador del operador
  **/
  eliminarOperador(uid) {
    swal({
      title: '¿Deseas eliminar este operador?',
      icon: 'warning',
      className: 'swalOperador',
      buttons: {
        cancel: {
          text: 'Cancelar',
          value: false,
          visible: true,
          dangerMode: true,
          className: 'btn-danger'
        },
        confirm: {
          text: 'Eliminarlo',
          value: true,
          visible: true,
          className: 'btn-primary'
        }
      },
    }).then((willDelete) => {
      if (willDelete) {
        swal({
          text: 'Introduzca la palabra \'ELIMINAR\' para continuar',
          content: 'input',
          // @ts-ignore
          button: {
            text: 'Continuar',
            closeModal: false
          }
        }).then(value => {
          if (!value) { throw null; }
          if (value !== 'ELIMINAR') {
            swal('¡Error!', 'No se ha escrito \'ELIMINAR\' correctamente', 'error');
          } else {
            const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
            this.operadoresService.eliminarOperador(this.listadoOperadores[indiceOperador].id).toPromise().then(data => {
              if (data.affectedRows === 1) {
                $('#operador' + uid).remove();
                // $("#operador"+uid).hide();
                // delete this.listadoOperadores[indiceOperador];
                this.listadoOperadores.splice(indiceOperador, 1);
                if ($('#tableOperadores > tbody')[0].children.length === 0) {
                  this.listadoOperadores = [];
                }
                swal('Se elimino correctamente', {
                  icon: 'success',
                });
              } else {
                let error = 'Hubo un error al eliminar';
                if (data.unidades !== undefined) {
                  error = data.unidades;
                }
                swal({
                  title: error,
                  icon: 'error',
                });
              }
            });
          }
        }).catch(error => {
          if (error) {
            swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
          } else {
            swal.stopLoading();
            // @ts-ignore
            swal.close();
          }
        });

      }
    });

  }
  /**
   * Historico de las unidades asignadas y de las incidencias
   * @param uid Identificador del operador
   * @param listadoIncidencias todas las asignaciones que ha tenido
   * @param listadoAsignacion todas las incidencias
  **/
  historicoOperdaores(uid) {
    this.historial = {};
    let arrayTemp: Array<any> = [];
    this.listadoAsignacion = [];
    this.listadoIncidencias = [];
    this.operadoresService.historialOperadores(uid).toPromise().then(data => {
      $('#asignadas-tab').tab('show');
      if (Object.entries(data.unidades).length > 0) {
        data.unidades.forEach(element => {
          arrayTemp.push({
            uid: element.uid,
            unidad: element.unidad,
            marca: element.marca,
            modelo: element.modelo,
            version: element.version,
            anio: element.anio,
            serie: element.serie,
            placas: element.placas,
            asignacion: moment(element.asignacion, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            termina: (element.activo === 1) ? ' Asignada actualmente ' : moment(element.termina, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm')
          });
        });
        this.listadoAsignacion = arrayTemp;
      }
      arrayTemp = [];
      if (Object.entries(data.incidencias).length > 0) {
        data.incidencias.forEach(element => {
          arrayTemp.push({
            uidIns: element.uidIns,
            uid: element.uid,
            unidad: element.unidad,
            placas: (element.placas == null) ? ' --- ' : element.placas,
            incidencia: element.incidencia,
            fecha: moment(element.fecha_incidencia, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm'),
            costo: element.costo,
            estatus: (element.estatus == null) ? 'Sin estatus' : element.estatus
          });
        });
        this.listadoIncidencias = arrayTemp;
      }
      const indiceOperador = this.listadoOperadores.map(x => x.uid).indexOf(uid);
      this.historial = {
        btn: 0,
        uidOperador: uid,
        nombre: this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno,
        indice: indiceOperador
      };

    });
  }
  /**
   * Cierra la venta de historial de operadores
   * las variables vuelven a estar vacias
  **/
  cerrarVentanaHistorial() {
    $('.incidencia' + this.historial.uidOperador).remove();
    this.historial = {};
    this.listadoAsignacion = [];
    this.listadoIncidencias = [];
  }
  /**
   * Prepara variables para nueva incidencia
   * @param uidUnidad Identificador de unidad
   * @param uidOperador Identificador de operador
   */
  modalNuevaIncidencia(uidUnidad = '', uidOperador = null) {
    this.model = {};
    let undadAlias = 'No hay unidad asignada';
    let indiceUnidad = -1;
    if ((Object.entries(this.historial).length === 0)) {
      this.historial = {};
      let indiceOperador = -1;
      indiceOperador = this.listadoOperadores.map(x => x.id).indexOf(uidOperador);
      if (indiceOperador === -1) {
        undadAlias = 'No hay operador asignado';
        uidUnidad = '';
        this.historial = { btn: 1 };
      } else {
        this.historial = {
          btn: 1,
          uidOperador: this.listadoOperadores[indiceOperador].uid,
          nombre: this.listadoOperadores[indiceOperador].nombre + ' ' + this.listadoOperadores[indiceOperador].paterno + ' ' + this.listadoOperadores[indiceOperador].materno,
          indice: indiceOperador
        };
        indiceUnidad = this.listadoUnidades.map(x => x.uidOperador).indexOf(this.historial.uidOperador);
      }
    } else {
      indiceUnidad = this.listadoUnidades.map(x => x.uidOperador).indexOf(this.historial.uidOperador);
    }
    if (indiceUnidad !== -1) {
      undadAlias = this.listadoUnidades[indiceUnidad].alias;
      uidUnidad = this.listadoUnidades[indiceUnidad].uidUnidad;
    }
    this.model = {
      unidad: uidUnidad,
      undadAlias: undadAlias,
      incidencia: '',
      costo: '',
      fecha: moment().format('YYYY-MM-DDTHH:mm')
    };
    $('#unidadError').html('');
    $('#costoError').html('');
    $('#incidenciaError').html('');
    $('#incidenciaError').html('');
  }
  /**
   * Cierra modal de incidencias
   * y regresa variables a vacias
   */
  cerrarModalIncidencia() {
    $('#nuevaincidencia').modal('hide');
    if (this.historial.btn === 1) {
      this.historial = {};
      this.listadoIncidencias = [];
    }
  }
  /**
   * Nueva incidencia
   * @param uidInc Identificador de unidad
   * @param fecha Cuando ocurrio la incidencia
   * @param costo Costo total de la incidencia
   * @param incidencia Descripcion de la incidencia
   */
  nuevaIncidencia() {
    let errorunidad = null, errorcosto = null, errorincidencia = null, errorfecha = null, nuevocosto = null;
    if ((this.model.unidad === undefined || this.model.unidad === '') && this.historial.btn === 0) {
      errorunidad = 'No hay unidad asignada';
    } else if ((this.model.unidad === undefined || this.model.unidad === '') && this.historial.btn === 1) {
      errorunidad = 'No hay operador asignado';
    }
    if (this.model.fecha === undefined || this.model.fecha === '') {
      errorfecha = 'Campo obligatorio';
    } else if (this.model.fecha.length !== 16) {
      errorfecha = 'Fecha incorrecta';
    }
    if (this.model.costo === undefined || this.model.costo === '') {
      errorcosto = 'Campo obligatorio';
    } else {
      let posCosto = this.model.costo.indexOf('.');
      let cuenta = 0;
      while (posCosto !== -1) {
        cuenta++;
        posCosto = this.model.costo.indexOf('.', posCosto + 1);
      }
      if (cuenta <= 1) {
        nuevocosto = this.model.costo;
      } else {
        errorcosto = 'Solo puede contener un punto.';
      }
    }
    if (this.model.incidencia === undefined || this.model.incidencia === '') {
      errorincidencia = 'Campo obligatorio';
    }
    if (errorunidad == null && errorcosto == null && errorincidencia == null && errorfecha == null) {
      const unidad = parseInt(this.model.unidad);
      const fecha = moment(this.model.fecha + ':00', 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      const datos = '\nUnidad: ' + this.model.undadAlias + '\nFecha: ' + moment(this.model.fecha, 'YYYY-MM-DDTHH:mm').format('DD-MM-YYYY HH:mm') + '\nCosto: ' + nuevocosto + '\nIncidencia: ' + this.model.incidencia;
      swal({
        title: '¡Nueva Incidencia!',
        text: 'Se creara con los siguientes datos:' + datos + '\n¿Deseas crear la incidencia?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'CREAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'CREAR') {
              swal('¡Error!', 'No se ha escrito \'CREAR\' correctamente', 'error');
            } else {
              this.operadoresService.nuevaIncidencia(unidad, nuevocosto, this.model.incidencia, fecha, this.listadoOperadores[this.historial.indice].id).toPromise().then(data => {
                if (data.length > 0) {
                  $('#nohayIncidencias').remove();
                  const fechaIncidencia = moment(data[0].fecha_incidencia, 'YYYY-MM-DD HH:mm:ssZ').format('DD-MM-YYYY HH:mm');
                  const placas = (data[0].placas == null) ? ' --- ' : data[0].placas;
                  const estatus = (data[0].estatus == null) ? 'Sin estatus' : data[0].estatus;
                  this.listadoIncidencias.push({
                    uidIns: data[0].uidIns,
                    uid: data[0].uid,
                    unidad: data[0].alias,
                    placas: placas,
                    incidencia: data[0].incidencia,
                    fecha: fechaIncidencia,
                    costo: data[0].costo,
                    estatus: estatus
                  });
                  // $('#tbl-incidencias > tbody').append('<tr id="inc'+data[0].uidIns+'" class="incidencia'+this.historial.uidOperador+'"><td>-</td><td>'+data[0].alias+'</td><td>'+placas+'</td><td>'+data[0].incidencia+'</td><td>'+fechaIncidencia+'</td><td>$ '+data[0].costo+'</td><td>$ '+estatus+'</td><td><button class="btn btn-primary btn-sm btonesO" (click)="modalEditarIncidencia('+data[0].uidIns+')" data-toggle="modal" data-target="#editarIncidencia">Editar Estatus</button></td></tr>');
                  this.cerrarModalIncidencia();
                  swal('Se creo nueva incidencia correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al crear nueva incidencia',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });

    } else {
      $('#unidadError').html(errorunidad);
      $('#costoError').html(errorcosto);
      $('#incidenciaError').html(errorincidencia);
      $('#fechaIncidenciaError').html(errorfecha);
    }
  }
  /**
   * Prepara las variables para nueva incidencia
   * @param uidInc Identificador de unidad
   */
  modalEditarIncidencia(uidInc) {
    this.model = {};
    const indiceIncidencia = this.listadoIncidencias.map(x => x.uidIns).indexOf(uidInc);
    this.model = {
      unidad: this.listadoIncidencias[indiceIncidencia].unidad,
      fecha: this.listadoIncidencias[indiceIncidencia].fecha,
      costo: this.listadoIncidencias[indiceIncidencia].costo,
      incidencia: this.listadoIncidencias[indiceIncidencia].incidencia,
      estatusInc: (this.listadoIncidencias[indiceIncidencia].estatus === 'Sin estatus') ? '' : this.listadoIncidencias[indiceIncidencia].estatus,
      uidInc: uidInc
    };
    $('#estatusErrorI').html('');
  }
  /**
   * Para editar el estatus de la incidencia
   * Resuelta, Pagada y Pendiente
   * @param estatusInc Estatus de la incidencia
   * @param uidInc Identificador de incidencia
   */
  editarIncidencia() {
    let errorEstatus = null;
    if (this.model.estatusInc.length === 0 || this.model.estatusInc === '') {
      errorEstatus = 'Campo obligatorio';
    } else if (this.model.estatusInc !== 'Resuelta' && this.model.estatusInc !== 'Pagada' && this.model.estatusInc !== 'Pendiente') {
      errorEstatus = 'La opción no es valida';
    }
    if (errorEstatus == null) {
      swal({
        title: '¡Editar Incidencia',
        text: 'Se modificara el estatus por: "' + this.model.estatusInc + '"\n¿Deseas modificar el estatus de la incidencia?',
        icon: 'warning',
        buttons: ['Cancelar', 'Continuar'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: 'Introduzca la palabra \'EDITAR\' para continuar',
            content: 'input',
            // @ts-ignore
            button: {
              text: 'Continuar',
              closeModal: false
            }
          }).then(value => {
            if (!value) { throw null; }
            if (value !== 'EDITAR') {
              swal('¡Error!', 'No se ha escrito \'EDITAR\' correctamente', 'error');
            } else {
              this.operadoresService.edtarIncidencia(this.model.uidInc, this.model.estatusInc).toPromise().then(data => {
                if (data['affectedRows'] === 1 && data['warningCount'] === 0) {
                  const indiceIncidencia = this.listadoIncidencias.map(x => x.uidIns).indexOf(this.model.uidInc);
                  this.listadoIncidencias[indiceIncidencia].estatus = this.model.estatusInc;
                  const tr = $('#incidencia' + this.model.uidInc);
                  // $("#incidencia"+this.model.uidInc).html(
                  //   '<td>'+tr[0].textContent.substring(0,1)+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].unidad+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].placas+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].incidencia+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].fecha+'</td>'+
                  //   '<td>$ '+this.listadoIncidencias[indiceIncidencia].costo+'</td>'+
                  //   '<td>'+this.listadoIncidencias[indiceIncidencia].estatus+'</td>'+
                  //   '<td>'+
                  //     '<button class="btn btn-primary btn-sm btonesO" (click)="modalEditarIncidencia('+this.model.uidInc+')" data-toggle="modal" data-target="#editarIncidencia">Editar Estatus</button> '+
                  //   '</td>'
                  // );
                  $('#editarIncidencia').modal('hide');
                  swal('Se actualizo correctamente', {
                    icon: 'success',
                  });
                } else {
                  swal({
                    title: 'Hubo un error al modificar la incidencia',
                    icon: 'error',
                    className: 'swalOperador',
                  });
                }
              });
            }
          }).catch(error => {
            if (error) {
              swal('¡Oh no!', 'Ocurrio un error intente nuevamente.', 'error');
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      $('#estatusErrorI').html(errorEstatus);
    }
  }


}
